/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeExportTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Export Type Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, December 09, 2019 - 04:11:05 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      12/09/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const EXPORTTYPE_LIST_CONTAINER_LOADED = 'EXPORTTYPE_LIST_CONTAINER_LOADED';
export const EXPORTTYPE_LIST_CONTAINER_UNLOADED = 'EXPORTTYPE_LIST_CONTAINER_UNLOADED';
export const EXPORTTYPE_LIST_TABLE_LOADED = 'EXPORTTYPE_LIST_TABLE_LOADED';
export const EXPORTTYPE_LIST_TABLE_UNLOADED = 'EXPORTTYPE_LIST_TABLE_UNLOADED';

export const EXPORTTYPE_LIST_CHANGE_GROUP = 'EXPORTTYPE_LIST_CHANGE_GROUP';
export const EXPORTTYPE_SELECT_ROW = 'EXPORTTYPE_SELECT_ROW';

export const EXPORTTYPE_ADD = 'EXPORTTYPE_ADD';
export const EXPORTTYPE_EDIT = 'EXPORTTYPE_EDIT';
export const EXPORTTYPE_DELETE = 'EXPORTTYPE_DELETE';
export const EXPORTTYPE_OPEN_WARNING = 'EXPORTTYPE_OPEN_WARNING';
export const EXPORTTYPE_CLOSE_WARNING = 'EXPORTTYPE_CLOSE_WARNING';
export const EXPORTTYPE_DELETE_DISABLE = 'EXPORTTYPE_DELETE_DISABLE';
export const EXPORTTYPE_VIEW_CHILD_ITEMS = 'EXPORTTYPE_VIEW_CHILD_ITEMS';

export const EXPORTTYPE_EDIT_CONTAINER_LOADED = 'EXPORTTYPE_EDIT_CONTAINER_LOADED';
export const EXPORTTYPE_EDIT_CONTAINER_UNLOADED = 'EXPORTTYPE_EDIT_CONTAINER_UNLOADED';
export const EXPORTTYPE_EDIT_FORM_LOADED = 'EXPORTTYPE_EDIT_FORM_LOADED';
export const EXPORTTYPE_EDIT_FORM_UNLOADED = 'EXPORTTYPE_EDIT_FORM_UNLOADED';

export const EXPORTTYPE_SET_GROUP_SELECT = 'EXPORTTYPE_SET_GROUP_SELECT';
export const EXPORTTYPE_EDIT_DATA_LOAD = 'EXPORTTYPE_EDIT_DATA_LOAD';

export const EXPORTTYPE_EDIT_CONTAINER_SUBMIT = 'EXPORTTYPE_EDIT_CONTAINER_SUBMIT';
export const EXPORTTYPE_EDIT_CONTAINER_CANCEL = 'EXPORTTYPE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeExportTypes.js